import { Icon } from '@/src/components/ui';

export const PartnerBadge = ({ reward }: { reward: string }) => {
  // const dashPattern = `url("data:image/svg+xml,%3csvg width='10' height='1' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0,0.5 L5,0.5 M10,0.5 L15,0.5' stroke='rgba(0, 194, 255, 1)' stroke-width='0.5'/%3e%3c/svg%3e")`;

  return (
    <>
      <h2 className="text-base! font-normal text-black/40">Partner badge</h2>
      <div className="mt-3 flex items-center justify-between">
        <div className="bg-bg-gray rounded-full flex items-center px-3 py-1.5 text-sm text-black/60">
          <Icon name="partner" className="size-5 text-blue-primary mr-2" />
          Partner of
          <span className="ml-2 font-medium text-black/80">Player 3</span>
        </div>
        {/* <div
          className="rounded-lg p-2 bg-white relative w-fit flex items-center"
          style={{
            width: '392px',
            height: '34px',
            borderRadius: '8px',
            paddingTop: '8px',
            paddingRight: '16px',
            paddingBottom: '8px',
            paddingLeft: '16px',
            backgroundImage: `${dashPattern}, ${dashPattern}, ${dashPattern}, ${dashPattern}`,
            backgroundRepeat: 'repeat-x, repeat-y, repeat-x, repeat-y',
            backgroundPosition: 'top, right, bottom, left',
            backgroundSize: '10px 2px, 2px 10px, 10px 2px, 2px 10px',
          }}
        >
          <span className="text-sm text-blue-primary leading-[18px]">
            Your reward:{' '}
            <span className="font-light text-black/80">{reward}</span>
          </span>
        </div> */}
      </div>
    </>
  );
};

type PartnerCheckmarkProps = {
  className?: string;
};

export const PartnerCheckmark = ({ className }: PartnerCheckmarkProps) => (
  <Icon
    name="partner"
    className={`text-blue-primary md:ml-2 ml-1 ${className}`}
  />
);
